import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subject } from 'rxjs';
import { IBoxService } from 'src/app/shared/services/i-box.service';
import { DataService } from 'src/app/shared/services/data.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CropperPosition, Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DocumentEditorService } from 'src/app/shared/services/document-editor.service';
import * as _ from 'underscore';
import * as async from 'async';
import * as XLSX from 'xlsx';
import { NgxExtendedPdfViewerService, PageRenderedEvent } from 'ngx-extended-pdf-viewer';
import { MailsService } from 'src/app/shared/services/mails.service';
import { IScanAPIService } from 'src/app/shared/services/iscan.service';
import { ScanSentToEditionComponent } from 'src/app/shared/models/iCourrier/scans/scan-sent-to-edition-component';
import { UserInfo } from 'src/app/shared/models/iCourrier/me/user-info';
import { MailFileDto } from 'src/app/shared/interfaces';
import { IButton, TranslateService } from '@devinforius/i-essentials';
import { ParseEmailService } from 'src/app/shared/services/parse-email.service';
import { RecipientsService } from 'src/app/shared/services/recipients.service';
import { FilesService } from 'src/app/shared/services/files.service';
import { MeService } from 'src/app/shared/services/me.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Mail } from 'src/app/shared/models/mails/mail';
import { MailDTO } from 'src/app/shared/interfaces/mails/mail-dto.interface';
import { NumerisationCentersService } from 'src/app/shared/services/numerisation_centers.service';
import { MailsLockUnlockService } from 'src/app/shared/services/mails-lock-unlock.service';
import { MailLockEntryDTO } from 'src/app/shared/interfaces/mails/mails-lock-dto.interface';
import { ConnectorsService } from 'src/app/shared/services/connectors.service';
import { AddIconForBreakTitle, ReplaceLineBreaks, separateNumberWithCharacters } from 'src/app/_pipes/format.pipe';
import { DocumentTemplate } from 'src/app/shared/models/iCourrier/document-template';
import { ExchangeEmail, ExchangeMailListColumn } from 'src/app/shared/models/exchange/exchange';

@Component({
  selector: 'app-courrier-create',
  templateUrl: './courrier-create.component.html',
  styleUrls: ['./courrier-create.component.scss'],
})
export class CourrierCreateComponent implements OnInit, OnDestroy {
  public sheetNames = [];
  public columnsExcel = [];
  public excelData = [];

  globalSubmitESubject: Subject<void> = new Subject<void>();
  public newMail: Mail;

  public answerMode: boolean;
  public editorMode: boolean; // if a template is chosen for answer, default is false and you must choose a template before
  public mailId: number;
  public currentFile: {
    name?: string;
    extension?: string;
    src?: Blob | string;
    id?: number;
    blob?: Blob;
    mailId?: number;
  };
  public currentFileInDropdown: number;
  public loadingFile = false;
  public cFile: File;
  public selectedTemplate: DocumentTemplate; // for docEditor
  public isSaveMode: boolean; // for docEditor
  public canSubmit: boolean; // info from courrierEditor for the submit button
  public formOutput: FormData; // to send Formdata in editor
  public mailMode: string; // mailModel mailNoModel emailnomodel emailmodel fileViewer
  public fullscreenMode: boolean;
  public visible = true;
  public form: UntypedFormGroup;
  public isFormSubmit = false;
  public linkMailId: number; // to see if it's an answer for title
  public convertedMail: ExchangeEmail;
  public currentCourrier: Mail;
  public isFormValid: boolean = false; // if not the recording button is disabled
  public isClickedSubmit = false;

  // Scan
  public duplicatedMailId: number; //* value that'll receive the id value of the chosen courrier from the 'courrier a créer' => 'Dupliquer un courrier récent' in Scan. It'll be used to get the courrier and patch its datas into the new courrier
  public scan: ScanSentToEditionComponent;
  public typeEntranSortant: string;
  public mail: Mail;
  public canLeaveEditor: boolean;

  public routerOrigin: string = null;
  public isEmailFile = false;
  public showOCR = false;
  public currentPageImageBase64: string = null;
  public dimensions: Dimensions = { width: 0, height: 0 };
  public cropperPosition: CropperPosition = {
    x1: 0,
    y1: 0,
    x2: 100,
    y2: 200,
  };
  public scale = 1;
  public transform: ImageTransform = {};

  croppedImage: Blob = null;
  public currentPage = 1;
  public arrayCanvas: { page: number; canvas: HTMLCanvasElement }[] = [];
  public textToCopy: string = null;
  public encodage: { label: string; value: string }[] = [
    {
      label: 'UTF-7',
      value: 'UTF-7',
    },
    {
      label: 'UTF-8',
      value: 'UTF-8',
    },
  ];
  public encoding = 'UTF-8';
  public tokenExchange: string = null;
  public dataFormDuplicate: FormGroup;
  public isDuplicateMode = false;
  public userInfo: UserInfo;
  public currentUserLockInfo: MailLockEntryDTO;

  public hasMainDest = false;
  public allDataSetToLoad = false;
  public numerisations_center = [];

  public listOfFiles: MailFileDto[] = [];

  public noMailModeButtons: IButton[] = [
    {
      text: 'Retour',
      id: 'backButton',
      styleClass: 'blue',
      click: () => {
        this.cancel();
      },
    },
    {
      text: 'Enregistrer',
      id: 'saveButton',
      styleClass: 'green',
      icon: 'bi bi-check-square-fill',
      click: () => {
        this.onSubmitClick();
      },
      disabled: !this.isFormValid,
    },
  ];

  public mailModeButtons: IButton[] = [
    {
      visible: !this.isDuplicateMode,
      icon: 'bi bi-check-square-fill',
      id: 'buttonCreateCourrierEnregistrer',
      text: 'Enregistrer',
      styleClass: 'green',
      click: () => {
        this.onSubmitClick();
      },
      disabled: !this.isFormValid,
    },
    {
      visible: this.isDuplicateMode,
      text: 'Enregistrer',
      styleClass: 'green',
      click: () => {
        this.duplicate();
      },
      disabled: !this.isFormValid,
    },
  ];

  public titleDisplayed: string = '';

  constructor(
    private route: ActivatedRoute,
    private iBoxService: IBoxService,
    private dataService: DataService,
    public toastr: ToastrService,
    private location: Location,
    private connectorsService: ConnectorsService,
    private iScanApiService: IScanAPIService,
    public spinner: NgxSpinnerService,
    private router: Router,
    public itemplate: DocumentEditorService,
    public pdfViewerService: NgxExtendedPdfViewerService,
    public mailsService: MailsService,
    public translate: TranslateService,
    private parseEmailService: ParseEmailService,
    private recipientsService: RecipientsService,
    private filesService: FilesService,
    private meService: MeService,
    private numerisationCentersService: NumerisationCentersService,
    private mailsLockUnlockService: MailsLockUnlockService
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.dataService.setCanLeaveEditor(true);

    // Origin From scan for backBtn
    if (history.state && history.state.origin) {
      this.routerOrigin = history.state.origin;
    }

    this.meService.getUserInfo().subscribe({
      next: (res) => {
        this.userInfo = res;
        this.getRouteParams();
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error(this.translate.translate('error.errorOccurredWhileFetchingUserInfos'));
      },
    });

    if (this.linkMailId) {
      sessionStorage.setItem('oldCourrier', this.linkMailId.toString());
    }

    // getCurrentMail ne trigger que quand setCurrentMail trigger. setCurrentMail ne trigger que quand on crée un nouveau courrier sur base d'un email importé a la main via exchange
    this.dataService.getCurrentMail.subscribe({
      next: (res: ExchangeMailListColumn) => {
        if (res) {
          res.dateDocument = res.date;
          this.mail = new Mail(res);
          this.isEmailFile = true;
          this.convertedMail = new ExchangeEmail(this.mail.emailObject);
          this.tokenExchange = this.mail.token;
          this.currentCourrier = this.mail;

          this.titleDisplayed = this.getNoMailModeTitle();

          if (this.currentCourrier.id) {
            this.recipientsService.fetchMailRecipientFullInfos(this.currentCourrier.id).subscribe({
              next: (res) => {
                if (res.length > 0) {
                  const index = res.map((x) => x.principal).indexOf(true);
                  index === -1 ? (this.hasMainDest = false) : (this.hasMainDest = true);
                } else {
                  this.hasMainDest = false;
                }

                this.mailsLockUnlockService.getLockInfo(this.currentCourrier.id).subscribe({
                  next: (res) => {
                    this.currentUserLockInfo = _.last(res.filter((x) => x.contactId === this.userInfo?.contactId));
                    let lastLockVersion = 0;
                    if (this.currentUserLockInfo) {
                      lastLockVersion = this.currentUserLockInfo.version;
                    } else if (this.currentCourrier.version) {
                      lastLockVersion = this.currentCourrier.version;
                    } else {
                      lastLockVersion = 1;
                    }
                    this.mailsLockUnlockService.postLockUnlock(this.currentCourrier.id, 'Write', lastLockVersion).subscribe({
                      next: () => {
                        this.toastr.success('Le courrier est verrouillé');
                        this.mailsLockUnlockService.getLockInfo(this.currentCourrier.id).subscribe({
                          next: (res) => {
                            this.currentUserLockInfo = _.last(res.filter((x) => x.contactId === this.userInfo.contactId));
                          },
                        });
                      },
                      error: () => {
                        this.spinner.hide();
                        this.toastr.error(this.translate.translate('error.errorOccurredWhileLockingMail'));
                      },
                    });
                  },
                  error: () => {
                    this.spinner.hide();
                    this.toastr.error(this.translate.translate('error.errorOccurredWhileFetchingLockInfos'));
                  },
                });
              },
              error: () => {
                this.spinner.hide();
                this.toastr.error(this.translate.translate('error.errorOccurredWhileFetchingRecipients'));
              },
            });
          }
        }
      },
    });
    this.dataFormDuplicate = JSON.parse(sessionStorage.getItem('duplicateForm'));
  }

  ngOnDestroy() {
    if (this.currentUserLockInfo && this.currentCourrier.id) {
      const data = {
        courrierIds: [this.currentCourrier.id],
      };
      return this.mailsLockUnlockService.unLock(this.currentUserLockInfo.lockMode, data).subscribe({
        next: () => {
          this.toastr.success('Le courrier est déverrouillé');
        },
      });
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event): void {
    event.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    if (this.currentUserLockInfo && this.currentCourrier.id) {
      const data = {
        courrierIds: [this.currentCourrier.id],
      };
      this.mailsLockUnlockService.unLock(this.currentUserLockInfo.lockMode, data).subscribe({
        next: () => {
          this.toastr.success('Le courrier est déverrouillé');
        },
      });
    }
  }

  pageRendered($event: PageRenderedEvent): void {
    const $canvas = $event.source.canvas;

    this.arrayCanvas.push({
      page: $event.pageNumber,
      canvas: $canvas,
    });
  }
  openOCR(): void {
    this.showOCR = true;
    if (this.arrayCanvas && this.arrayCanvas.length > 0 && this.currentPage) {
      this.arrayCanvas.map((item) => {
        if (item.page === this.currentPage) {
          this.currentPageImageBase64 = null;
          this.currentPageImageBase64 = item.canvas.toDataURL('img/jpeg');
        }
      });
    } else {
      const scale = {
        width: null,
        height: null,
        scale: 1,
      };

      this.pdfViewerService.getPageAsImage(this.currentPage, scale).then(
        (res) => {
          this.currentPageImageBase64 = null;
          this.currentPageImageBase64 = res;
        },
        () => {
          this.spinner.hide();
          this.toastr.error(this.translate.translate('error.errorOccurredWhileOCR'));
        }
      );
    }
  }
  imageCropped(event: ImageCroppedEvent): void {
    console.log(event);
    this.croppedImage = event.blob;
  }

  cropperReady(dimensions: Dimensions): void {
    this.dimensions = dimensions;
    this.cropperPosition = {
      x1: 150,
      y1: 50,
      x2: 500,
      y2: 200,
    };
  }

  startOCR(): void {
    const imageBytes = this.croppedImage;
    this.spinner.show();
    this.itemplate.postOCR(imageBytes).subscribe({
      next: (res) => {
        this.textToCopy = res.text.replace(/\n/g, '<br/>');
        this.toastr.success('Le texte a été copié dans le presse-papier! (' + res.meanConfidence + ' de confiance)');
        navigator.clipboard.writeText(res.text).then(
          function () {
            console.info('Async: Copying to clipboard was successful!');
          },
          function (err) {
            console.error('Async: Could not copy text: ', err);
          }
        );
        this.spinner.hide();
      },
      error: () => {
        this.toastr.error('Océrisation impossible');
        this.spinner.hide();
      },
    });
  }

  reset(): void {
    this.textToCopy = null;
    this.cropperPosition = {
      x1: 150,
      y1: 50,
      x2: 500,
      y2: 200,
    };
  }
  b64toBlob(dataURI: string): Blob {
    console.log(dataURI);
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
  }

  setDatasForCreationViaScan(params): void {
    this.mailMode = 'fileViewer';
    this.typeEntranSortant = 'E';
    // next we will check in which url we are : newcourrier, link or duplicate
    // With "newCourrier" we do not need to set anything special
    if (this.route.snapshot.url[2].path === 'duplicateRecent') {
      this.duplicatedMailId = params.newMailScanDuplicateMailId;
    }

    //Next we will set the datas inside this.scan
    const qrCodeDatas = this.route.snapshot.queryParams as {
      centernum: string;
      codeclassid: string;
      description: string;
      destcntid: string;
      finished: string;
      splitGuid: string;
      srcid: string;
      svcid: string;
    };
    let blobFile = null;
    async.parallel(
      [
        (callback) => {
          this.iScanApiService.downloadSplit(params.newMailLotScanGuid, qrCodeDatas.splitGuid).subscribe({
            next: (blob: Blob) => {
              blobFile = blob;
              this.currentFile = {
                name: this.route.snapshot.queryParams.description ? this.route.snapshot.queryParams.description : 'fichierScanné.pdf',
                extension: 'pdf',
                src: blob,
              };
              callback();
            },
            error: () => {
              this.spinner.hide();
              this.toastr.error(this.translate.translate('error.errorOccurredWhileDownloadingFile'));
            },
          });
        },
      ],
      () => {
        //Setting scans datas
        this.scan = {
          file: {
            ServiceProprietaireId: qrCodeDatas?.svcid ? +qrCodeDatas.svcid : null,
            SourceId: qrCodeDatas?.srcid ? +qrCodeDatas.srcid : null,
            CentreNumId: qrCodeDatas?.centernum ? +qrCodeDatas.centernum : null,
            DestinataireContactId: qrCodeDatas?.destcntid ? +qrCodeDatas.destcntid : null,
            description: this.route.snapshot.queryParams.description,
            CodeClassementId: qrCodeDatas?.codeclassid ? +qrCodeDatas.codeclassid : null,
          },
          blob: blobFile,
          finished: this.route.snapshot.queryParams.finished === 'true' ? true : false,
          scanGuid: params.newMailLotScanGuid,
          splitGuid: qrCodeDatas?.splitGuid,
          type: this.route.snapshot.url[2].path,
        };

        this.allDataSetToLoad = true;
        this.spinner.hide();
      }
    );
  }

  getNumerisationCenters(): Promise<boolean> {
    return new Promise((resolve) => {
      this.numerisationCentersService.getGlobalCentreNumerisation().subscribe({
        next: (res) => {
          this.numerisations_center = [];
          if (res?.length > 0) {
            res.map((item) => {
              this.numerisations_center.push({ label: item.description, value: item.codeQr, item: item });
            });
          } else {
            this.numerisations_center = [];
          }
          resolve(true);
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(this.translate.translate('error.errorOccurredWhileRetrievingGlobalCenterNumerization'));
        },
      });
    });
  }

  getRouteParams(): void {
    const routeParams = this.route.snapshot.params;
    //checking if infos from a new courrier coming from a scan
    if (routeParams.newMailLotScanGuid) {
      this.getNumerisationCenters().then(() => {
        this.setDatasForCreationViaScan(routeParams);
      });
    } else if (routeParams.mode) {
      this.mailMode = routeParams.mode;
      this.isDuplicateMode = routeParams.mode === 'duplicate' ? true : false;
    } else {
      this.mailMode = null;
      this.dataService.setSidebarSmall(false);
    }

    if (routeParams.mailId) {
      this.loadingFile = true;
      this.mailId = +routeParams.mailId;
      this.mailsService.fetchMailsById(this.mailId).subscribe({
        next: (res: MailDTO) => {
          this.currentCourrier = new Mail(res);
          async.parallel(
            [
              (callback) => {
                this.recipientsService.fetchMailRecipientFullInfos(this.currentCourrier.id).subscribe(
                  (res) => {
                    if (res.length > 0) {
                      const index = res.map((x) => x.principal).indexOf(true);
                      index === -1 ? (this.hasMainDest = false) : (this.hasMainDest = true);
                    } else {
                      this.hasMainDest = false;
                    }
                    callback();
                  },
                  () => {
                    this.spinner.hide();
                    this.toastr.error('Une erreur est survenue lors de la récupération des destinataires');
                    callback();
                  }
                );
              },
              (callback) => {
                this.mailsLockUnlockService.getLockInfo(this.currentCourrier.id).subscribe({
                  next: (res) => {
                    if (res) {
                      this.currentUserLockInfo = _.last(res.filter((x) => x.contactId === this.userInfo.contactId));
                    } else {
                      this.currentUserLockInfo = null;
                    }
                    callback();
                  },
                  error: () => {
                    this.spinner.hide();
                    this.toastr.error('Une erreur est survenue lors de la récupération des informations de verrouillage');
                    callback();
                  },
                });
              },
              (callback) => {
                this.filesService.fetchMailFiles(this.mailId).subscribe({
                  next: (res) => {
                    this.listOfFiles = res;
                    this.currentFile = null;
                    if (this.listOfFiles?.length > 0) {
                      const arrayExtensionValid = ['docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg', 'svg', 'eml', 'msg', 'rtf', 'txt', 'xlsx', 'xls'];
                      for (let i = 0; i < this.listOfFiles.length; i++) {
                        if (arrayExtensionValid.includes(this.listOfFiles[i].extension.toLowerCase())) {
                          this.currentFile = this.listOfFiles[i];
                          this.currentFileInDropdown = this.listOfFiles[i].id;
                          break;
                        }
                      }
                      if (this.currentFile?.id) {
                        this.downloadFile(this.mailId, this.currentFile.id).then(() => {
                          callback();
                        });
                      } else callback();
                    } else callback();
                  },
                  error: () => {
                    this.spinner.hide();
                    this.toastr.error('Une erreur est survenue lors de la récupération des fichiers');
                  },
                });
              },
            ],
            () => {
              if (routeParams.isAnswer === 'true') {
                this.answerMode = true;
              } else {
                this.answerMode = false;
              }
              this.titleDisplayed = !this.mailMode ? this.getNoMailModeTitle() : this.getMailModeTitle();

              this.allDataSetToLoad = true;
              this.spinner.hide();
            }
          );
        },
        error: (error) => {
          this.spinner.hide();
          console.error('Error : ', error);
        },
      });
    }
  }

  private downloadFile(mailId: number, fileId: number): Promise<boolean> {
    return new Promise((resolve) => {
      this.iBoxService.downLoadFile(mailId, fileId).subscribe({
        next: (response) => {
          const blob = new Blob([response], { type: response.type });
          this.isEmailFile = false;
          if (this.currentFile.extension.toLowerCase() === 'eml' || this.currentFile.extension.toLowerCase() === 'msg') {
            this.parseEmailFile(blob).then(() => {
              this.loadingFile = false;
              resolve(true);
            });
          } else if (
            this.currentFile.extension.toLowerCase() === 'rtf' ||
            this.currentFile.extension.toLowerCase() === 'txt' ||
            this.currentFile.extension.toLowerCase() === 'docx'
          ) {
            this.currentFile.blob = response;
            this.cFile = new File([response], this.currentFile.name, {
              type: response.type,
              lastModified: Date.now(),
            });
            this.loadingFile = false;
            resolve(true);
          } else if (this.currentFile.extension.toLowerCase() === 'xlsx') {
            const reader: FileReader = new FileReader();
            reader.readAsBinaryString(blob);
            reader.onload = (e: any) => {
              /* create workbook */
              const binarystr: string = e.target.result;
              const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
              this.excelData = [];
              this.columnsExcel = [];
              this.sheetNames = [];
              for (let i = 0; i < wb.SheetNames.length; i++) {
                /* selected the first sheet */
                const wsname: string = wb.SheetNames[i];
                this.sheetNames.push(wsname);
                const ws: XLSX.WorkSheet = wb.Sheets[wsname];
                const columnsArray: any = XLSX.utils.sheet_to_json(wb.Sheets[wsname], { header: 1 })[0];
                for (let j = 0; j < columnsArray.length; j++) {
                  columnsArray[j] = { field: columnsArray[j], header: columnsArray[j] };
                }
                this.columnsExcel.push(columnsArray);
                /* save data */
                this.excelData.push(
                  XLSX.utils.sheet_to_json(ws, {
                    blankrows: false,
                    raw: true,
                    rawNumbers: true,
                  })
                ); // to get 2d array=> add an object
                this.loadingFile = false;
                resolve(true);
              }
            };
          } else {
            this.currentFile.src = window.URL.createObjectURL(blob);
            this.loadingFile = false;
            resolve(true);
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors du téléchargement du fichier');
          console.error('Error : ', error);
          resolve(true);
        },
      });
    });
  }

  public checkDestinatairePrincipal(event): void {
    if (event.length > 0) {
      const index = event.map((x) => x.principal).indexOf(true);
      index === -1 ? (this.hasMainDest = false) : (this.hasMainDest = true);
    } else {
      this.hasMainDest = false;
    }
  }

  public receiveSelectedTemplate(event): void {
    this.selectedTemplate = event;
    this.fullscreenMode = true;
  }

  public saveDoc(): void {
    this.isSaveMode = true;
  }

  public onSubmitClick(): void {
    this.isFormSubmit = true;
    this.isClickedSubmit = true;
    this.canLeaveEditor = true;
    this.globalSubmitESubject.next();

    if (this.typeEntranSortant === 'S') {
      sessionStorage.setItem('showModalDestinataire', '1');
    }
  }

  getLocksAccess(): void {
    if (this.currentCourrier.id) {
      this.mailsLockUnlockService.getLockInfo(this.currentCourrier.id).subscribe({
        next: (res) => {
          this.currentUserLockInfo = _.last(res.filter((x) => x.contactId === this.userInfo.contactId));
          this.unLock();
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(this.translate.translate('error.errorOccurredWhileFetchingLockInfos'));
        },
      });
    }
  }

  unLock(): Promise<boolean> {
    return new Promise((resolve) => {
      const data = {
        courrierIds: [this.currentCourrier.id],
      };
      if (this.currentUserLockInfo?.lockMode && this.currentCourrier.id) {
        this.mailsLockUnlockService.unLock(this.currentUserLockInfo.lockMode, data).subscribe({
          next: () => {
            this.toastr.success('Le courrier est déverrouillé');
            resolve(true);
          },
          error: () => {
            this.spinner.hide();
            this.toastr.error(this.translate.translate('error.errorOccurredWhileUnLocking'));
          },
        });
      } else {
        resolve(true);
      }
    });
  }

  public canSubmitReceived(canSubmit: boolean): void {
    if (canSubmit === true) {
      this.canSubmit = true;
    } else {
      this.canSubmit = false;
    }
  }

  public changeFileToDisplay(event: { originalEvent: PointerEvent; value: number }): void {
    this.loadingFile = true;
    this.currentFile = this.listOfFiles.find((file) => file.id === event.value);
    this.downloadFile(this.currentFile.mailId, this.currentFile.id);
  }

  public receiveCurrentFile(file: string): void {
    if (
      (this.mailMode !== 'mailModel' && this.mailMode !== 'mailNoModel' && this.mailMode !== 'emailnomodel' && this.mailMode !== 'emailmodel') ||
      file === 'reload'
    ) {
      this.currentFile = {};
      if (this.mailMode === 'edit') {
        this.mailMode = 'edit';
      } else {
        this.mailMode = 'fileViewer';
      }
      if (file === 'reload') {
        this.ngOnInit();
        this.selectedTemplate = null;
        this.answerMode = true;
        this.fullscreenMode = false;
        if (this.mailMode !== 'mailModel' && this.mailMode !== 'emailmodel') {
          this.mailMode = null;
        }
      }
    }
  }

  parseEmailFile(file): Promise<boolean> {
    return new Promise((resolve) => {
      this.isEmailFile = true;
      this.parseEmailService.parseEmailFile(file, this.currentFile.extension).subscribe({
        next: (response) => {
          if (
            this.mailMode &&
            this.mailMode !== 'mailModel' &&
            this.mailMode !== 'mailNoModel' &&
            this.mailMode !== 'emailnomodel' &&
            this.mailMode !== 'emailmodel' &&
            this.mailMode !== 'edit'
          ) {
            this.mailMode = 'fileViewer';
          }
          this.convertedMail = response;
          resolve(true);
        },
        error: (error) => {
          this.spinner.hide();
          this.toastr.error(this.translate.translate('error.errorOccurredWhileParsingFile'));
          this.convertedMail = null;
          this.loadingFile = false;
          console.error('Error : ', error);
          resolve(true);
        },
      });
    });
  }

  public onFormChangeEvent(formData): void {
    this.formOutput = formData;
  }

  public receiveNewMail(mail: Mail): void {
    this.newMail = mail;
  }

  back(): void {
    localStorage.removeItem('iCourrier_point_id_send');
    if (this.currentUserLockInfo) {
      this.unLock();
      if (this.routerOrigin) {
        this.router.navigateByUrl('/private/ic/courriers/' + localStorage.getItem('activeCategoryCourrier'), {
          state: { isScan: true },
        });
      } else {
        this.location.back();
      }
    } else {
      this.location.back();
    }
  }

  cancel(): void {
    this.unLock();
    if (this.routerOrigin) {
      this.router.navigateByUrl('/private/ic/courriers/' + localStorage.getItem('activeCategoryCourrier'), {
        state: { isScan: true },
      });
    } else {
      this.location.back();
    }
  }

  receiveFormState(event): void {
    this.form = event.form;
    this.isFormSubmit = event.isFormSubmit;
  }

  receiveLinkMailId(id): void {
    this.linkMailId = id;
    sessionStorage.setItem('oldCourrier', this.linkMailId.toString());
  }

  public receiveFormValidSt(isFormValid: boolean): void {
    this.isFormValid = isFormValid;
    this.mailModeButtons = [...this.mailModeButtons.map((button) => ({ ...button, disabled: !isFormValid }))];
    this.noMailModeButtons = [...this.noMailModeButtons.map((button) => ({ ...button, disabled: !isFormValid }))];
  }

  public getscan(scanMailFile): void {
    this.currentFile = {
      name: scanMailFile.description,
      extension: 'pdf',
    };
    this.iBoxService.downLoadScanFile(scanMailFile.scanId, scanMailFile.id).subscribe({
      next: (res) => {
        const blob = new Blob([res], { type: res.type });
        this.currentFile.src = window.URL.createObjectURL(blob);
      },
      error: (error) => {
        this.spinner.hide();
        this.toastr.error(this.translate.translate('error.errorOccurredWhileDownloadingFile'));
        console.error('Error : ', error);
      },
    });
  }

  zoomOut(): void {
    this.scale -= 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  zoomIn(): void {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  resetImage(): void {
    this.scale = 1;
    this.transform = {};
  }

  changeEncodage(): void {
    this.connectorsService
      .postEmailByIDFromExchange(this.tokenExchange, { mailUniqueId: this.currentCourrier.id.toString() }, this.encoding)
      .subscribe({
        next: (res) => {
          this.convertedMail = new ExchangeEmail(res);
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(this.translate.translate('error.errorOccurredWhileChangingEncoding'));
        },
      });
  }

  duplicate(): void {
    this.isFormSubmit = true;
    this.isClickedSubmit = true;
    this.canLeaveEditor = true;
    this.globalSubmitESubject.next();
    this.spinner.show();
  }

  getCurrentUserLockInfoFromChildComponent(event): void {
    this.currentUserLockInfo = event;
  }

  getNoMailModeTitle(): string {
    if (!this.currentCourrier?.typeExchange) {
      return '#' + this.currentCourrier?.id;
    } else if (this.currentCourrier) {
      return this.currentCourrier?.objet?.substring(0, 75) ?? 'Courrier sans objet';
    }
  }

  getMailModeTitle(): string {
    if (this.linkMailId) {
      const pipeSeparateNumber = new separateNumberWithCharacters();
      return this.translate.translate('createCourrier.replyToMail') + ' #' + pipeSeparateNumber.transform(this.linkMailId);
    } else {
      if (!this.scan) {
        const pipeLineBreaks = new ReplaceLineBreaks();
        const pipeAddIcon = new AddIconForBreakTitle();
        const titleFirstPipe = pipeLineBreaks.transform(this.currentCourrier?.objet);
        const titleSecondPipe = pipeAddIcon.transform(titleFirstPipe, this.currentCourrier?.typeEntrantSortant);
        const finalTitle = titleSecondPipe?.substring(0, 75);

        return !this.currentCourrier?.typeExchange
          ? '#' + this.currentCourrier?.id
          : '' + this.currentCourrier?.objet
            ? finalTitle
            : pipeAddIcon.transform('Courrier sans objet', this.currentCourrier?.typeEntrantSortant);
      } else {
        return this.translate.translate('createCourrier.createMail');
      }
    }
  }
}
